import React, { useEffect, useState } from 'react';
import './login.css';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { getOttSettings } from '../../Api/api';
import FullKeypad from '../homePage/search/fullkeypad';
import ActivateTvScreen from './activiateTvScreen';
import LoginTvScreen from './loginTvScreen';

const Login = () => {
    const { ref, focusKey } = useFocusable({
        focusKey: 'LOGIN_PAGE',
        trackChildren: true
    });

    const [mobileNumber, setMobileNumber] = useState('');
    const [showVerifyOTP, setShowVerifyOTP] = useState(false);
    const [ottSetting, setOttSetting] = useState({});
    const [showNumPad, setShowNumPad] = useState(true);

    useEffect(() => {
        loadOttSettings();
    }, []);

    const loadOttSettings = async () => {
        const ottSettingRes = await getOttSettings();
        if (ottSettingRes.success) {
            setOttSetting({ ...ottSettingRes.data, piPageSetting: ottSettingRes?.piPageSetting });
        }
    };

    return (
        <FocusContext.Provider value={focusKey}>
            <div ref={ref} className="loginPage">
                <div className='loginLogo'>
                    <img src={ottSetting?.logo ?? ''} alt="logo" />
                </div>
                <div id='loginContent' style={{ display: 'flex' }}>
                    {!showVerifyOTP && !showNumPad && (
                        <>
                            <FullKeypad
                                style={{
                                    width: '50vw',
                                    height: '90%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                fromLogin={true}
                                setSearchKey={setMobileNumber}
                                setShowNumPad={setShowNumPad}
                            />
                            <div style={{
                                backgroundColor: 'white',
                                position: 'absolute',
                                width: '2px',
                                height: '40%',
                                top: '60%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                display: 'block'
                            }} />
                        </>
                    )}

                    <LoginTvScreen
                        mobileNumber={mobileNumber}
                        showVerifyOTP={showVerifyOTP}
                        setShowVerifyOTP={setShowVerifyOTP}
                        setMobileNumber={setMobileNumber}
                        ottSetting={ottSetting}
                    />

                    <ActivateTvScreen ottSetting={ottSetting} />
                </div>
            </div>
        </FocusContext.Provider>
    );
};

export default Login;
